// ===== ProfileDialog.js =====
import React from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ProfilePage from "../Pages/Profile";

const ProfileDialog = ({ profileId, open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            sx={{ zIndex: 99999 }}
            PaperProps={{
                sx: {
                    width: "800px",
                    height: "600px",
                    padding: 0,
                    backgroundColor: "#f2f2f2",
                    position: "relative",
                },
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: "absolute",
                    top: 25,
                    left: 25,
                    zIndex: 10,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: "50%",
                    padding: "4px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
            >
                <CloseIcon />
            </IconButton>

            {profileId && (
                <ProfilePage
                    profileId={profileId}
                    onClose={onClose}
                    isPopup={true} // ✅ זה החידוש
                />
            )}
        </Dialog>
    );
};

export default ProfileDialog;
